// TOP OF FILE
import argentina from "../../assets/images/flags/svns/argentina.jpg";
import australia from "../../assets/images/flags/svns/australia.jpg";
import brazil from "../../assets/images/flags/svns/brazil.jpg";
import canada from "../../assets/images/flags/svns/canada.jpg";
import chile from "../../assets/images/flags/svns/chile.jpg";
import england from "../../assets/images/flags/svns/england.jpg";
import fiji from "../../assets/images/flags/svns/fiji.jpg";
import france from "../../assets/images/flags/svns/france.jpg";
import georgia from "../../assets/images/flags/svns/georgia.jpg";
import germany from "../../assets/images/flags/svns/germany.jpg";
import gb from "../../assets/images/flags/svns/great-britain.jpg";
import ireland from "../../assets/images/flags/svns/ireland.jpg";
import italy from "../../assets/images/flags/svns/italy.jpg";
import japan from "../../assets/images/flags/svns/japan.jpg";
import kenya from "../../assets/images/flags/svns/kenya.jpg";
import namibia from "../../assets/images/flags/svns/namibia.jpg";
import netherlands from "../../assets/images/flags/svns/netherlands.jpg";
import nz from "../../assets/images/flags/svns/new-zealand.jpg";
import portugal from "../../assets/images/flags/svns/portugal.jpg";
import romania from "../../assets/images/flags/svns/romania.jpg";
import russia from "../../assets/images/flags/svns/russia.jpg";
import samoa from "../../assets/images/flags/svns/samoa.jpg";
import scotland from "../../assets/images/flags/svns/scotland.jpg";
import sa from "../../assets/images/flags/svns/south-africa.jpg";
import spain from "../../assets/images/flags/svns/spain.jpg";
import tonga from "../../assets/images/flags/svns/tonga.jpg";
import uruguay from "../../assets/images/flags/svns/uruguay.jpg";
import usa from "../../assets/images/flags/svns/usa.jpg";
import wales from "../../assets/images/flags/svns/wales.jpg";

// MAP
export const svnsFlags: Record<string, string> = {
  Argentina: argentina,
  Australia: australia,
  Brazil: brazil,
  Canada: canada,
  Chile: chile,
  England: england,
  Fiji: fiji,
  France: france,
  Georgia: georgia,
  Germany: germany,
  "Great Britain": gb,
  Ireland: ireland,
  Italy: italy,
  Japan: japan,
  Kenya: kenya,
  Namibia: namibia,
  Netherlands: netherlands,
  "New Zealand": nz,
  Portugal: portugal,
  Romania: romania,
  Russia: russia,
  Samoa: samoa,
  Scotland: scotland,
  "South Africa": sa,
  Spain: spain,
  Tonga: tonga,
  Uruguay: uruguay,
  USA: usa,
  Wales: wales,
};